var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"case-tertiary-metrics"},[_c('Tabs',[_c('TabItem',{attrs:{"name":_vm.labels.temp.resultsTabsTimeline}},[_c('CaseTimeline')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }